const AinaaEmblem = ({ size = 40, className = '', variant = 'default' }) => {
  const isInverted = variant === 'inverted';
  const shieldFill = isInverted ? '#F5F3EE' : '#0F1B2D';
  const innerStroke = isInverted ? '#0F1B2D' : '#C4A35A';
  const starFill = isInverted ? '#0F1B2D' : '#EDECEA';
  const lineFill = isInverted ? '#0F1B2D' : '#C4A35A';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Shield body — no stroke */}
      <path
        d="M60 4L108 28V72C108 104 86 128 60 136C34 128 12 104 12 72V28L60 4Z"
        fill={shieldFill}
      />

      {/* Inner border */}
      <path
        d="M60 14L100 34V72C100 98 82 120 60 128C38 120 20 98 20 72V34L60 14Z"
        fill="none"
        stroke={innerStroke}
        strokeWidth="1.5"
        opacity="0.6"
      />

      {/* Star */}
      <path
        d="M60 38L67 56H86L71 68L76 86L60 74L44 86L49 68L34 56H53L60 38Z"
        fill={starFill}
      />

      {/* Horizontal lines below star */}
      <line x1="38" y1="96" x2="82" y2="96" stroke={lineFill} strokeWidth="1.5" opacity="0.6" />
      <line x1="44" y1="104" x2="76" y2="104" stroke={lineFill} strokeWidth="1" opacity="0.4" />
      <line x1="48" y1="110" x2="72" y2="110" stroke={lineFill} strokeWidth="0.8" opacity="0.3" />
    </svg>
  );
};

export default AinaaEmblem;
